import {AbstractChatMessage} from '../../message/abstract-chat-message';

export class SocketQuery{
    public id;
    public data;
    public action;
    public owner: any;
    public message : AbstractChatMessage;
    public resolve : Function | null;
    private  canBeResolved : boolean = false;
    public  run : Function;
    requiredLogin: boolean = false;
    constructor(data: any,action: any,requiredLogin: boolean = false){
        // to prevent bug use uniqe id
        var min = 0;
        var max = 100000;
        // and the formula is:
        this.id = Math.floor(Math.random() * (max - min + 1)) + min;
        this.data = data;
        this.action = action;
        this.requiredLogin = requiredLogin;

    }
    registerOwner(owner: any){
                this.owner  = owner;
    }
    registerMessage(message : AbstractChatMessage){
                this.message  = message;
    }
    setResolvable(canBeResolved : boolean){
        this.canBeResolved = canBeResolved;
    }
    isResolvable() {
        return this.canBeResolved;
    }
}